export const WeekDays = {
	'mon': { long: '月曜日', short: '月' },
	'tue': { long: '火曜日', short: '火' },
	'wed': { long: '水曜日', short: '水' },
	'thu': { long: '木曜日', short: '木' },
	'fri': { long: '金曜日', short: '金' },
	'sat': { long: '土曜日', short: '土' },
	'sun': { long: '日曜日', short: '日' }
}
export type WeekDay = keyof typeof WeekDays
